import AbstractTrigger from '@/ghost/service/Triggers/AbstractTrigger'
import { isDev } from '@/common/util/environment'

export default class GetTestCasesTrigger extends AbstractTrigger {
  constructor($locator) {
    super($locator, 'getTestCases')
    this.browserRequests = $locator.browserRequests
  }

  async onEvent(action) {
    const { method } = action
    try {
      await super.onEvent({})

      const { response } = await this.callGetTestCases(method)

      if (response.status === 'ERROR') {
        this.onError(response.answer, method)
      } else {
        this.setTestCases(method, response.answer.testCases)
      }
    } catch (error) {
      this.onError(error, method)
    }
  }

  async onError(
    error,
    method,
    path = 'ghost/service/GetTestCasesTrigger.onEvent'
  ) {
    if (isDev())
      console.warn(
        `Error fetching test cases for method ${method} on ${this.restAPI.getGetTestCasesUrl(
          this.endpoint
        )}, using fallback test cases if available`,
        error
      )
    // If the webservice call fails or returns an error, use the fallback test cases
    this.setTestCases(method)
  }

  async callGetTestCases(method) {
    const { language, remoteId, publicKey } = this.$store.state
    const url = this.restAPI.addJSessionID(
      this.restAPI.getGetTestCasesUrl(this.endpoint)
    )

    const requestData = this.storeFactory.create('requestData', {
      url,
      objectData: {
        paymentMethod: method,
        locale: language.replace('-', '_'),
        remoteId,
        publicKey,
        clientVersion: this.restAPI.getClientVersion(),
        device: this.restAPI.getDeviceData(),
        wsUser: this.restAPI.getWSUser()
      },
      headers: {},
      options: {}
    })
    return await this.browserRequests.post(requestData)
  }

  setTestCases(method, testCases = undefined) {
    this.$store.dispatch('setNestedMethodTestData', {
      nestedMethod: method,
      testCases
    })
    this.proxy.send(this.storeFactory.create('testCasesSet', { method }))
  }
}
